export class GarantieTdb {
    id: string;
    label: string;
    labelFranchise: string;
    labelTauxPriseEnCharge: string;
    labelDureePriseEnCharge: string;
    labelQuotite: string;
    tooltip: string;
    opened = false;
    refused = false;

    listGarantie: GarantieTdb[];
}
